import { ColumnDef } from "@tanstack/react-table";
import { useLanguage } from "hooks";
/* eslint-disable react-hooks/exhaustive-deps */
import { t } from "i18next";
import moment from "moment";
import { useMemo } from "react";
import { ItemsTable, PersonInfo } from "ui";

import { UnverifiedReseller } from "../../resellers.types";
import { UnverifiedResellersTableProps } from "./UnverifiedResellersTable.types";

import styles from "./UnverifiedResellersTable.module.scss";

const UnverifiedResellersTable = ({
  resellersList,
  sorting,
  setSorting,
  isLoading,
  onRowClick
}: UnverifiedResellersTableProps) => {
  const { currentLanguage } = useLanguage();
  const columns: Array<ColumnDef<UnverifiedReseller, UnverifiedReseller[]>> =
    useMemo(
      () => [
        {
          id: "name",
          accessorKey: "name",
          header: t("Reseller"),
          size: 22,
          minSize: 22,
          cell: ({ row }) => (
            <PersonInfo
              image={row.original.image}
              personName={`${row.original.firstname} ${row.original.lastname}`}
              nameClassName={styles.resellersTable_name}
              bottomText={[row.original.gender && t(row.original.gender), `${row.original.age} y.o.`]
                .filter(Boolean)
                .join(" · ")}
            />
          )
        },
        {
          id: "location",
          accessorKey: "location",
          header: t("Location"),
          size: 21,
          minSize: 21,
          cell: ({ row }) => (
            <div>{`${row.original.country}, ${row.original.city} `}</div>
          )
        },
        {
          header: t("Phone"),
          size: 20,
          minSize: 20,
          cell: ({ row }) => <div>{`${row.original.phoneNumber}`}</div>
        },
        {
          header: t("Mobile Money"),
          size: 20,
          minSize: 20,
          cell: ({ row }) => <div>{row.original.mobileMoneyNumber ?? "-"}</div>
        },
        {
          id: "createdAt",
          accessorKey: "createdAt",
          header: t("Registration date"),
          size: 17,
          minSize: 17,
          cell: ({ row }) => (
            <pre>
              {`${moment(row.original.createdAt).format("DD/MM/YYYY")}`}
              {"\n"}
              {`${moment(row.original.createdAt).format("HH:mm")}`}
            </pre>
          )
        }
      ],
      [resellersList, currentLanguage]
    );

  return (
    <ItemsTable
      className={styles.resellersTable}
      columns={columns}
      data={resellersList}
      sorting={sorting}
      setSorting={setSorting}
      isLoading={isLoading}
      skeletonHeight={65}
      onRowClick={onRowClick}
    />
  );
};

export default UnverifiedResellersTable;
